import { createContext, useContext, type PropsWithChildren } from 'react'

interface ScopeSelectorContextValue {
  margin?: string
}

const ScopeSelectorContext = createContext<ScopeSelectorContextValue | undefined>(undefined)

export const ScopeSelectorProvider = ({
  children,
  margin,
}: PropsWithChildren<ScopeSelectorContextValue>) => (
  <ScopeSelectorContext.Provider value={{ margin }}>{children}</ScopeSelectorContext.Provider>
)

export const useScopeSelectorContext = () => useContext(ScopeSelectorContext)
